module.exports = __webpack_public_path__ + "media/images/application/template/icon-technical-literature-a18d85e1c1fd888fdf7b818a81c5df44.svg";